module.exports = __webpack_public_path__ + "221ec9c78499624ad0eaf7b6f8155e8c.fbx";